'use strict';

var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");

var _Symbol$iterator = require("@babel/runtime-corejs3/core-js-stable/symbol/iterator");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof _Symbol && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var isWindows = process.platform === 'win32'; // Regex to split a windows path into into [dir, root, basename, name, ext]

var splitWindowsRe = /^(((?:[a-zA-Z]:|[\\\/]{2}[^\\\/]+[\\\/]+[^\\\/]+)?[\\\/]?)(?:[^\\\/]*[\\\/])*)((\.{1,2}|[^\\\/]+?|)(\.[^.\/\\]*|))[\\\/]*$/;
var win32 = {};

function win32SplitPath(filename) {
  var _context;

  return _sliceInstanceProperty(_context = splitWindowsRe.exec(filename)).call(_context, 1);
}

win32.parse = function (pathString) {
  var _context2;

  if (typeof pathString !== 'string') {
    throw new TypeError("Parameter 'pathString' must be a string, not " + _typeof(pathString));
  }

  var allParts = win32SplitPath(pathString);

  if (!allParts || allParts.length !== 5) {
    throw new TypeError("Invalid path '" + pathString + "'");
  }

  return {
    root: allParts[1],
    dir: allParts[0] === allParts[1] ? allParts[0] : _sliceInstanceProperty(_context2 = allParts[0]).call(_context2, 0, -1),
    base: allParts[2],
    ext: allParts[4],
    name: allParts[3]
  };
}; // Split a filename into [dir, root, basename, name, ext], unix version
// 'root' is just a slash, or nothing.


var splitPathRe = /^((\/?)(?:[^\/]*\/)*)((\.{1,2}|[^\/]+?|)(\.[^.\/]*|))[\/]*$/;
var posix = {};

function posixSplitPath(filename) {
  var _context3;

  return _sliceInstanceProperty(_context3 = splitPathRe.exec(filename)).call(_context3, 1);
}

posix.parse = function (pathString) {
  var _context4;

  if (typeof pathString !== 'string') {
    throw new TypeError("Parameter 'pathString' must be a string, not " + _typeof(pathString));
  }

  var allParts = posixSplitPath(pathString);

  if (!allParts || allParts.length !== 5) {
    throw new TypeError("Invalid path '" + pathString + "'");
  }

  return {
    root: allParts[1],
    dir: _sliceInstanceProperty(_context4 = allParts[0]).call(_context4, 0, -1),
    base: allParts[2],
    ext: allParts[4],
    name: allParts[3]
  };
};

if (isWindows) module.exports = win32.parse;else
  /* posix */
  module.exports = posix.parse;
module.exports.posix = posix.parse;
module.exports.win32 = win32.parse;